import {
  withMethods,
  signalStoreFeature,
  WritableStateSource,
} from '@ngrx/signals';
import { pipe } from 'rxjs';
import { tapResponse } from '@ngrx/operators';
import { rxMethod } from '@ngrx/signals/rxjs-interop';
import { FirebaseAuthOutput } from './utils/firebase-auth';
import { map, filter, tap, exhaustMap } from 'rxjs/operators';
import { mapFirebaseAuthErrorToMessage } from './utils/auth-error';
import { withCustomCallState } from '../utils/with-custom-call-state.feature';

type PassResetDeps = WritableStateSource<FirebaseAuthOutput['state']> &
  Pick<FirebaseAuthOutput['methods'], '_recoverPassword'>;

export function withPassResetResources<T extends PassResetDeps>(store: T) {
  return signalStoreFeature(
    withCustomCallState('passReset'),

    withMethods((innerStore) => ({
      passReset: rxMethod<string>(
        pipe(
          map((email) => email.trim()),
          tap((email) => {
            if (!email) {
              innerStore._passResetSetError(
                "Escribe tu correo arriba y presiona de nuevo 'Recuperar Contraseña.",
              );
            }
          }),
          filter((email) => !!email),
          tap(() => innerStore._passResetSetLoading()),
          exhaustMap((email) =>
            store._recoverPassword(email).pipe(
              tapResponse({
                next: () => innerStore._passResetSetSuccess(),
                error: (err: unknown) =>
                  innerStore._passResetSetError(
                    mapFirebaseAuthErrorToMessage(err),
                  ),
              }),
            ),
          ),
        ),
      ),
    })),
  );
}
